// extracted by mini-css-extract-plugin
module.exports = {"multiComponent":"EditOfferSlots_multiComponent__4RPAv","toggleSwitch":"EditOfferSlots_toggleSwitch__ebcPN"};